export const SETTING_RESET = "SETTING_RESET" as const;
export const SETTING_SET = "SETTING_SET" as const;
export const CONFIG_SET = "CONFIG_SET" as const;
export const LOCAL_CONFIG_SET = "LOCAL_CONFIG_SET" as const;
export const FEATURE_SETTING_SET = "FEATURE_SETTING_SET" as const;
